import stockService from "../../../../common/services/stockService"
import utils from 'utils'
class ticketedPointListCtrl {
    constructor($scope, $uibModal, httpRequest, sweetalert, $state, initSortService) {
        // 查询展开
        $scope.isFilterCollapsed = true
        $scope.sale = JSON.parse(localStorage.user_info).sale
        const typecodeArrStr = '["manage_type","ovat_disk_type"]'
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.tableDropdownConfig = [{
            label: '编辑',
            handler (item) {
                $state.go(`system.basedata.ticketedPoint.edit`, {
                    ukeyId: item.ukeyId
                })
            },
            showWhile (item, hasPermit) {
                return hasPermit('edit_ticketedPoint')
            },
        }, {
            label: '启用',
            handler (item) {
                const method = `modTaxDiskStatus`
                $scope[method](item.ukeyId, item.status)
            },
            showWhile (item, hasPermit) {
                return hasPermit('edit_ticketedPoint') && item.status === 0
            },
        }, {
            label: '禁用',
            handler (item) {
                const method = `modTaxDiskStatus`
                $scope[method](item.ukeyId, item.status)
            },
            showWhile (item, hasPermit) {
                return hasPermit('edit_ticketedPoint') && item.status === 1
            },
        }]
        $scope.readDisk = function () {
            if (checkSoapBeforeTaxCore()) return
            $uibModal.open({
                templateUrl: 'readDisk.html',
                controller: ['$scope', '$uibModalInstance', 'httpRequest', 'formvalidateApi', 'sweetalert', '$rootScope', 'logger', function ($scope, $uibModalInstance, httpRequest, formvalidateApi, sweetalert, $rootScope, logger) {
                    utils.loading('正在读盘')
                    $scope.sale = JSON.parse(localStorage.user_info).sale
                    $scope.param = {
                        status: 1,
                        manageType: '0',
                        differentInvoice: 0,
                        deviceType: '0',
                        electronicQuota: 0,
                        generalQuota: 0,
                        specialQuota: 0,
                        volumeQuota: 0,
                        vehicleQuota: 0,
                        diskType: 2,
                        ukeyCode:'',
                        ukeyName:'',
                        accountId: $scope.sale && $scope.sale.saleBankAccount && $scope.sale.saleBankAccount.accountId || 0
                    }
                    $scope.validateRules = {
                        diskCode: [{
                            erromsg: '只允许数字，最多32位字符',
                            condition (value) {
                                // 规则
                                return !(value && value.length >= 0 && value.length <= 32)
                            },
                        }],
                        diskName: [{
                            erromsg: '必填项，企业自定义名称，最多100位字符',
                            condition (value) {
                                // 规则
                                return !(value && value.length > 0 && value.length <= 100)
                            },
                        }],
                        diskNo: [{
                            erromsg: '必填项，硬件厂家出厂时的硬件设备号，12位字符',
                            condition (value) {
                                // 规则
                                return !(value && value.length == 12)
                            },
                        }],
                        ukeyName: [
                            {
                                erromsg: '必填项，企业自定义名称，最多100位字符',
                                condition(value) {
                                    // 规则
                                    return !(value && value.length > 0 && value.length <= 100);
                                },
                            },
                        ],
                        ukeyCode: [
                            {
                                erromsg: '必填项，最多4位字符',
                                condition(value) {
                                    // 规则
                                    return !(value && value.length > 0 && value.length <= 4);
                                },
                            },
                        ],
                        specialQuota: [{
                            erromsg: '必填项，只允许输入金额，小数点前12位，后两位',
                            condition (value) {
                                // 规则
                                return !isRuledMoney(value)
                            },
                        }],
                        generalQuota: [{
                            erromsg: '必填项，只允许输入金额，小数点前12位，后两位',
                            condition (value) {
                                // 规则
                                return !isRuledMoney(value)
                            },
                        }],
                        electronicQuota: [{
                            erromsg: '必填项，只允许输入金额，小数点前12位，后两位',
                            condition (value) {
                                // 规则
                                return !isRuledMoney(value)
                            },
                        }],
                        volumeQuota: [{
                            erromsg: '必填项，只允许输入金额，小数点前12位，后两位',
                            condition (value) {
                                // 规则
                                return !isRuledMoney(value)
                            },
                        }],
                        vehicleQuota: [{
                            erromsg: '必填项，只允许输入金额，小数点前12位，后两位',
                            condition (value) {
                                // 规则
                                return !isRuledMoney(value)
                            },
                        }],
                        accountId: [{
                            erromsg: '必填项',
                            condition (value) {
                                // 规则
                                console.log(value)
                                return !((!$scope.bankList.length && !value) || ($scope.bankList.length && value))
                            },
                        }],
                    }
                    httpRequest.post_getEnableBankOfOrg().then((res) => {
                        $scope.bankList = res.data.value.map((item) => ({
                            accountId: item.accountId,
                            bankText: `${item.bankAccount}|${item.bank}`,
                        }))
                    })
                    $scope.diskNameChange=function diskNameChange(){
                        $scope.param.ukeyName=$scope.param.diskName
                    }
                    $scope.diskCodeChange=function diskCodeChange(){
                        $scope.param.ukeyCode=$scope.param.diskCode
                    }
                    function isRuledMoney (value) {
                        const reg = /(^[1-9][0-9]{0,11}$)|(^[0]$)|(^[0]\.\d{0,2}$)|(^[1-9][0-9]{0,11}\.\d{0,2}$)/
                        return (value || value == 0) && reg.test(value)
                    }
                    stockService.getDiskInfo().then(diskInfo => {
                        httpRequest.post_getJSONObject({
                            data: diskInfo
                        }).then(res => {
                            console.log(res)
                            const result = res.data.value
                            if (result.retcode == 0) {
                                $scope.param.saleCreditCode = result.TaxCode
                                $scope.param.saleName = result.CorpName || $scope.sale.saleName
                                $scope.param.diskCode = String(result.MachineNo)
                                $scope.param.ukeyCode = String(result.MachineNo)
                                $scope.param.deviceType = result.IsBW == 1 ? '1' : '0'
                                if (result.responseMsg.DATA) {
                                    $scope.param.diskNo = result.responseMsg.DATA.Jssbxx && result.responseMsg.DATA.Jssbxx.Jspbh
                                    $scope.param.electronicQuota = result.responseMsg.DATA.Dzfp && result.responseMsg.DATA.Dzfp.Dzkpxe || 0
                                    $scope.param.specialQuota = result.responseMsg.DATA.Zzszyptfp && result.responseMsg.DATA.Zzszyptfp.Zyfpkpxe || 0
                                    $scope.param.generalQuota = result.responseMsg.DATA.Zzszyptfp && result.responseMsg.DATA.Zzszyptfp.Ptfpkpxe || 0
                                    $scope.param.volumeQuota = result.responseMsg.DATA.Jsfp && result.responseMsg.DATA.Jsfp.Dzkpxe || 0
                                    $scope.param.vehicleQuota = result.responseMsg.DATA.Jdcxstyfp && result.responseMsg.DATA.Jdcxstyfp.Dzkpxe || 0
                                }
                            } else {
                                logger.logError(result.retmsg)
                            }
                        })
                    }).finally(() => {
                        utils.loaded()
                    })
                    $scope.cancel = function cancel () {
                        $uibModalInstance.dismiss()
                    }
                    $scope.submit = function () {
                        if ($scope.sale.saleCreditCode != $scope.param.saleCreditCode) return logger.logError('当前企业税号与税盘税号不一致！')
                        if ($scope.param.deviceType == 1) $scope.param.diskCode = $scope.param.diskNo
                        if (formvalidateApi.run()) {
                            if (!$scope.param.accountId) return logger.logError('开户银行不能为空')
                            utils.loading('正在保存盘数据')
                            httpRequest.get_getDiskByDiskNoDiskCode($scope.param.diskNo, $scope.param.diskCode).then(res => {
                                if (res.data.value) {
                                    sweetalert.confirm('操作提醒', '当前税盘信息已存在，是否需要更新税盘内容？').then(() => {
                                        $scope.param = $.extend(res.data.value, {
                                            diskName: $scope.param.diskName,
                                            specialQuota: $scope.param.specialQuota,
                                            generalQuota: $scope.param.generalQuota,
                                            electronicQuota: $scope.param.electronicQuota,
                                            volumeQuota: $scope.param.volumeQuota,
                                            vehicleQuota: $scope.param.vehicleQuota,
                                            accountId: $scope.param.accountId,
                                            defaultPayee: $scope.param.defaultPayee,
                                            defaultDrawer: $scope.param.defaultDrawer,
                                            defaultReviewer: $scope.param.defaultReviewer,
                                            ukeyCode:$scope.param.ukeyCode,
                                            ukeyName:$scope.param.ukeyName,
                                            saleCreditCode : $scope.param.saleCreditCode,
                                            saleName: $scope.param.saleName
                                        })
                                        httpRequest.post_updateTaxDisk($scope.param, '读取成功').then(() => {
                                            $rootScope.$broadcast('userInfoChanged')
                                            $uibModalInstance.close()
                                        })
                                    })
                                } else {
                                    httpRequest.post_addTaxDisk($scope.param, '读取成功').then(() => {
                                        $rootScope.$broadcast('userInfoChanged')
                                        $uibModalInstance.close()
                                    })
                                }
                            }).finally(() => {
                                utils.loaded()
                            })
                        }
                    }
                }],
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-lg',
            }).result.then(() => {
                queryTaxInfo0()
            })
        }
        // 导入
        // 导入配置
        $scope.importconfig = {
            code: 'TAX_DISK',
            validate: {
                pattern: '.xlsx,.xls,.xml',
                _validate: {
                    size: {
                        min: 10,
                        max: '10MB'
                    },
                    duration: {
                        min: '10s',
                        max: '5m'
                    },
                    accept: '.xlsx,.xls,.xml',
                },
            },
            callback () {
                // 回掉，可选
                queryUkeyList('2')
                queryTaxInfo0()
            },
        }
        // 导入服务器版金税盘配置
        $scope.importServerConfig = {
            ...$scope.importconfig,
            code: 'TAX_SERVER_DISK',
            callback () {
                queryUkeyList('2')
                queryTaxInfo1()
            },
        }
        // modal
        $scope.openUkeyList = function (v) {
            queryUkeyList(v)
        }

        function queryUkeyList (v) {
            const req = {
                pageNum: 1,
                pageSize: 10,
                param: {
                    diskCodeName: '',
                    status: '', // 1只查询正在使用的ukey,按查询值则使用$scope.param1.param.status
                    diskId: v,
                    ukeyCodeName: '',
                },
            }
            if (v == 2) return
            httpRequest.post_getSysUkeyList(req).then((res) => {
                const getUkey = res.data.value
                getUkey.param = req.param
                // $scope.resData0.push(getUKey.list)
                const modalInstance = $uibModal.open({
                    templateUrl: 'myModalContent.html',
                    controller: 'modalTaxDiskCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-lg',
                    resolve: {
                        items1 () {
                            return getUkey
                        },
                    },
                })
            })
        }


        // 单机版
        // 初始化 req 参数

        // 返回数据
        $scope.resData0 = []
        $scope.isOnSubmit0 = false
        $scope.statusList0 = [{
            id: '',
            text: '全部',
        }, {
            id: 0,
            text: '未启用',
        }, {
            id: 1,
            text: '启用',
        }]

        // 分页参数
        $scope.pageOpt0 = {
            totalItems: 0, // 组件初始化设置总页数
            currentPage: 1, // 设置显示第一页
            maxSize: 10, // 每一叶显示记录数
        }
        // 查询参数
        $scope.param0 = {
            pageNum: $scope.pageOpt0.currentPage,
            pageSize: $scope.pageOpt0.maxSize,
            param: {
                diskCodeName: '',
                diskType: 2,
                status: '',
                manageType:'',
                ukeyCode:'',
                ukeyName:''
            },
        }
        $scope.reset = function () {
            $scope.param0.param = {
                diskCodeName: '',
                diskType: 2,
                status: '',
                manageType:'',
                ukeyCode:'',
                ukeyName:''
            }
        }
        // $scope.reset()
        // 表头排序
        $scope.orderMap = {}
        $scope.selectedHandle = function () {
            $scope.param0.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param0.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            queryTaxInfo0()
        }
        const queryTaxInfo0 = function () {
            let params=JSON.parse(JSON.stringify($scope.param0.param))
            params.diskType=2
            const req = {
                // 传入前台的分页数据
                pageSize: $scope.pageOpt0.maxSize,
                pageNum: $scope.pageOpt0.currentPage,
                param: params,
                orderMap: $scope.param0.orderMap,

            }
            httpRequest.post_getPageQrySysUkeyList(req).then((res) => {
                $scope.isOnSubmit0 = false
                $scope.resData0 = res.data.value.list

                // 获取后台分页数据 回写分页组件
                $scope.pageOpt0.totalItems = res.data.value.total
                $scope.pageOpt0.currentPage = ++res.data.value.prePage
                $scope.pageOpt0.maxSize = res.data.value.pageSize
            })
        }


        // 初始话请求参数
        queryTaxInfo0()


        // 搜索
        $scope.searchlist0 = function () {
            $scope.isOnSubmit0 = true
            queryTaxInfo0()
        }

        $scope.pageChanged0 = function () { // 点击页码发起查询
            queryTaxInfo0()
        }

        // 服务器版
        // 初始化 req 参数

        // 返回数据
        $scope.resData1 = []
        $scope.isOnSubmit1 = false
        $scope.statusList1 = [{
            id: '',
            text: '全部',
        }, {
            id: 0,
            text: '未启用',
        }, {
            id: 1,
            text: '启用',
        }]

        // 分页参数
        $scope.pageOpt1 = {
            totalItems: 0, // 组件初始化设置总页数
            currentPage: 1, // 设置显示第一页
            maxSize: 10, // 每一叶显示记录数
        }
        $scope.param1 = {
            pageNum: $scope.pageOpt1.currentPage,
            pageSize: $scope.pageOpt1.maxSize,
            param: {
                diskCodeName: '',
                diskType: 1,
                status: '',
            },
        }

        const queryTaxInfo1 = function () {
            const _diskCodeName = $scope.param1.param.diskCodeName
            const _status = $scope.param1.param.status
            const req = {
                // 传入前台的分页数据
                pageSize: $scope.pageOpt1.maxSize,
                pageNum: $scope.pageOpt1.currentPage,
                param: {
                    diskCodeName: _diskCodeName,
                    status: _status,
                    diskType: 1,
                },

            }
            httpRequest.post_getPageQrySysUkeyList(req).then((res) => {
                $scope.isOnSubmit1 = false
                $scope.resData1 = res.data.value.list
                // 获取后台分页数据 回写分页组件
                $scope.pageOpt1.totalItems = res.data.value.total
                $scope.pageOpt1.currentPage = ++res.data.value.prePage
                $scope.pageOpt1.maxSize = res.data.value.pageSize
            })
        }

        // 初始化列表
        queryTaxInfo1()
        // 单机版禁用确认弹窗
        // 禁用确认弹窗
        $scope.modTaxDiskStatus = function (g, s) {
            // 弹出确认框
            const msg = s === 1 ? '确定要禁用该单机版服务器吗？' : '确定要启用该单机版服务器吗？'
            const title = s === 1 ? '禁用提醒' : '启用提醒'
            sweetalert.swal({
                title,
                text: msg,
                // type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#0096e7',
                confirmButtonText: '确定',
                cancelButtonText: '手滑了',
                closeOnConfirm: true,
                closeOnCancel: true,
            }, (isConfirm) => {
                if (isConfirm) {
                    // 确定处理
                    const _ukeyId = g
                    const _status = s === 1 ? 0 : 1
                    httpRequest.post_enableUkey({
                        ukeyId: _ukeyId,
                        status: _status,
                    }).then((res) => {
                        // 禁用/启用成功
                        for (let i = 0, l = $scope.resData0.length; i < l; i++) {
                            if ($scope.resData0[i].ukeyId === _ukeyId) {
                                if ($scope.resData0[i].status === 1) {
                                    $scope.resData0[i].status = 0
                                } else {
                                    $scope.resData0[i].status = 1
                                }
                            }
                        }
                    })
                }
            })
        }
        // 服务器版禁用确认弹窗
        // 禁用确认弹窗
        // $scope.modTaxDiskStatus1 = function (g, s) {
        //     // 弹出确认框
        //     const msg = s === 1 ? '如果禁用金税盘服务器，则下面绑定使用的Ukey将统一被禁用，请确认后谨慎操作！' : '确定要启用该金税盘服务器吗？'
        //     const title = s === 1 ? '禁用提醒' : '启用提醒'
        //     sweetalert.swal({
        //         title,
        //         text: msg,
        //         // type: "warning",
        //         showCancelButton: true,
        //         confirmButtonColor: '#0096e7',
        //         confirmButtonText: '确定',
        //         cancelButtonText: '手滑了',
        //         closeOnConfirm: true,
        //         closeOnCancel: true,
        //     }, (isConfirm) => {
        //         if (isConfirm) {
        //             // 确定处理
        //             const _diskId = g
        //             const _status = s === 1 ? 0 : 1
        //             httpRequest.post_enableTaxDisk({
        //                 diskId: _diskId,
        //                 status: _status,
        //             }).then((res) => {
        //                 // 禁用/启用成功
        //                 for (let i = 0, l = $scope.resData1.length; i < l; i++) {
        //                     if ($scope.resData1[i].diskId === _diskId) {
        //                         if ($scope.resData1[i].status === 1) {
        //                             $scope.resData1[i].status = 0
        //                         } else {
        //                             $scope.resData1[i].status = 1
        //                         }
        //                     }
        //                 }
        //             })
        //         }
        //     })
        // }


        // 搜索
        $scope.searchlist1 = function () {
            $scope.isOnSubmit1 = true
            queryTaxInfo1()
        }
        $scope.pageChanged1 = function () { // 点击页码发起查询
            queryTaxInfo1()
        }
    }
}
ticketedPointListCtrl.$inject = ['$scope', '$uibModal', 'httpRequest', 'sweetalert', '$state', 'initSortService']
export default ticketedPointListCtrl



// WEBPACK FOOTER //
// ./src/app/system/basedata/ticketedPoint/ticketedPointListCtrl.js